import { render } from "./PagosList.vue?vue&type=template&id=3475bf74"
import script from "./PagosList.vue?vue&type=script&lang=js"
export * from "./PagosList.vue?vue&type=script&lang=js"

import "./PagosList.vue?vue&type=style&index=0&id=3475bf74&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__